export const BASE_URL = "https://ldssetupdev.ilsp.gr/fc/";
export const URL_REGISTRY = "https://ldssetupdev.ilsp.gr/registryui/";
export const URL_REGISTRY_PARTICIPANT_FORM = URL_REGISTRY + "participant-form";

export const GET_TRANSLATIONS = BASE_URL + "translation/get-messages";

export const SEARCH_URL = BASE_URL + "search";

export const GET_DATASET_LANDING_PAGE = (id) => {
  return BASE_URL + "dataset/display/" + id;
};

export const GET_DATASET = (id) => {
  return BASE_URL + "dataset/" + id;
};
export const MATCH_DATASET_TO_POLICY = (id) => {
  return BASE_URL + "dataset/" + id;
};
export const GET_FULL_OFFER = (id) => {
  return BASE_URL + "offer/" + id;
};
export const PARTICIPANT_LIST = BASE_URL + "participants/";
export const SEARCH_PARTICIPANTS = BASE_URL + "participants/search";
